import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { postData } from "src/utils/axios/serverHelper";

interface ProgramLogRequest {
    programId: string;
    actionType?: string;
    deviceType?: string;
    remark?: string;
}

/**
 * KIOSK ???? ?? ?? (???? ?? ??? ??)
 */
export const postProgramLog = async (request: ProgramLogRequest): Promise<void> => {
    try {
        await postData<ProgramLogRequest, ResponseDto<void>>(
            `${config.apiUrl}/program-log`,
            {
                programId: request.programId,
                actionType: request.actionType ?? "OPEN",
                deviceType: request.deviceType ?? "KIOSK",
                remark: request.remark,
            }
        );
    } catch (e) {
    }
};
